import * as React from "react";
import "./style.scss";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppContext } from "../context/AppContext";
import IconLeftArrow from "../../../assets/icon-arrow-left.svg";
import IconSettings from "../../../assets/icon-settings.svg";
export interface HeaderProps {
  title: string;
  logo: string;
  message: string;
}

const Header: React.FC<HeaderProps> = (props: HeaderProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const displaySettingBtn = location.pathname.includes("/settings");
  const {
    isChatActive,
    setIsChatActive,
    isChatLoading,
    setCancelStreamRequested,
    isDarkMode,
    showTovForm,
    setShowTovForm,
    showDeleteView,
    setShowDeleteView,
    setTovFormMode,
    setExceedsWordLimit,
  } = useAppContext();

  const { title, logo, message } = props;

  const handleBack = () => {
    if (displaySettingBtn) {
      // on settings page — handle intermediate views
      if (showDeleteView) {
        setShowDeleteView(false);
      } else if (showTovForm) {
        setShowTovForm(false);
        setTovFormMode("");
        setExceedsWordLimit(false);
      } else {
        setTovFormMode("");
        navigate("/");
      }
      return;
    }

    if (isChatActive && !displaySettingBtn) {
      setIsChatActive(false);
    }
    navigate("/");
  };

  useEffect(() => {
    if (isDarkMode) {
      document.body.classList.add("dark");
    } else {
      document.body.classList.remove("dark");
    }
    console.log("Dark mode:", isDarkMode);
  }, [isDarkMode]);

  return (
    <section>
      <div className="custom-header">
        <div className="left-header-btn">
          {(displaySettingBtn || isChatActive) && (
            <button className="back-btn" onClick={handleBack} disabled={isChatLoading}>
              <IconLeftArrow />
              <span className="back-text">Back</span>
            </button>
          )}
        </div>
        <div className="header-btns">
          {!displaySettingBtn && (
            <button
              onClick={() => {
                navigate("/settings");
              }}
              disabled={isChatLoading}
            >
              <IconSettings />
            </button>
          )}
        </div>
      </div>
    </section>
  );
};

export default Header;
